import React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

import Survey from 'modules/surveys/store/models/v2/Survey'

interface Props {
  surveyId?: number
}

const SurveyRemoved = ({ surveyId }: Props) => {
  const [foundSurvey, setFoundSurvey] = React.useState<boolean>(true)

  useEffect(() => {
    Survey.fetch({ id: surveyId ? String(surveyId) : undefined }).catch(() => setFoundSurvey(false))
  }, [])

  if (!surveyId || foundSurvey) return null

  return (
    <Box background="radicalRed200" borderRadius={{ all: 'abs012' }} paddingY="s2" paddingX="s12">
      <Text.Normal size="200" color="grey1000">
        {i18n.t('surveys.form.delete.survey_not_found')}
      </Text.Normal>
    </Box>
  )
}

export default observer(SurveyRemoved)
